import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    ReferenceInput,
    NullableBooleanInput,
    minValue,
    FormDataConsumer,
    useDataProvider,
    DataProviderContext,
    NumberInput,
} from 'react-admin';

import { Ecom_Products } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { useNavigate } from 'react-router-dom';
import TotalAmountInput from '../../common/inputs/TotalAmountInput';
import DiscountInput from '../../common/DiscountInput';
import FileUpload from '../../common/inputs/FileUpload';
import { createCustomGoDataProvider } from '../../services';

const NonCategoryProductEdit = () => {
    let { productTemplateId, productId } = useParams();
    const navigate = useNavigate();
    if (!productTemplateId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_products', apiEndpoint: '/ecom/products' },
            ]),
        [baseDataProvider],
    );

    return (
        // @ts-ignore
        <DataProviderContext.Provider value={customDataProvider}>
            <Edit
                title={<ProductTitle />}
                redirect={false}
                mutationMode="pessimistic"
                mutationOptions={{
                    onSuccess: () => {
                        navigate(-1);
                    },
                }}
                transform={(data: any) => {
                    return {
                        ...data,
                        amount: Number(data.amount),

                    };
                }}
                id={productId}
                resource={'ecom_products'}
            >
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload
                        type="VIDEO_THUMBNAIL"
                        label="select images"
                        source="images"
                        accept="image/*"
                        multiple={true}
                    />
                    <FileUpload
                        type="PDF_NOTES"
                        source="previewPdf"
                        label="select preview pdf"
                        accept="application/pdf"
                        multiple={false}
                    />
                    <NullableBooleanInput
                        source={'addressRequired'}
                        fullWidth
                        name={'Address Required'}
                    />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <NumberInput
                        type={'number'}
                        source="mrp"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <DiscountInput />
                    <NumberInput
                        type={'number'}
                        source="gstPercentage"
                        prefix={'%'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return (
                                <div className="w-full">
                                    <TotalAmountInput source="amount" formData={formData} />
                                </div>
                            );
                        }}
                    </FormDataConsumer>
                    <NumberInput
                        type={'number'}
                        source="appleAmount"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="validityInDays"
                        defaultValue={0}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <TextInput
                        source="textDescription"
                        multiline
                        rows={4}
                        fullWidth
                        validate={[required()]}
                    />
                    <HTMLEditorInput
                        source={'htmlDescription'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </DataProviderContext.Provider>
    );
};

const ProductTitle = () => {
    const record = useRecordContext<Ecom_Products>();
    return record ? <span>{record.name}</span> : null;
};

export default NonCategoryProductEdit;
